import interceptors from './interceptors'
import mdui from 'mdui';

export default class httpService {
    private axios: any;
    private store: any;

    constructor(store: any) {
        this.axios = new interceptors().getInterceptors();
        this.store = store;
    }


    /**
     * post请求
     * @param params  参数
     * @param jwt   是否token校验
     * @param modulename    模块
     * @param head
     */
    public postData(params: object, jwt: boolean, modulename: string, head: string = '') {
        if (head) {
            this.axios.defaults.headers.post['Content-Type'] = head;
        } else {
            this.axios.defaults.headers.post['Content-Type'] = 'text/javascript;charset=UTF-8';
        }
        if (jwt) {
            if (!this.store.state.token) {
                // 消息弹窗
                mdui.snackbar({
                    message: '请登录',
                    position: 'top'
                });
                this.store.commit('openLogin', 1);
            } else {
                this.axios.defaults.headers.common['Authorization'] = "Bearer " + this.store.state.token;
            }

        } else {
            this.axios.defaults.headers.common['Authorization'] = "";
        }

        // 开启loding动画
        this.store.commit("lodingStrat");
        //临时全局变量
        var is = window.location.href;
        console.log(is);
        var url = '';
        if (is.indexOf("localhost") != -1) {
            // 本地调试没有s
            url = modulename;
        } else {
            url = '/s/' + modulename;
        }


        return new Promise((resolve, reject) => {
            this.axios.post(url, params, {
                headers: { isJwt: jwt, setHead: head }
            }).then((res: any) => {
                this.resultHandle(res, resolve);
            }).catch((err: any) => {
                reject(err.message);
                // 关闭loding动画
                this.store.commit("lodingEnd");
            });
        });
    }

    /**
     *
     * @param res
     * @param resolve
     */
    public resultHandle(res: any, resolve: any) {
        // TODO 区分业务错误代码和请求错误代码
        if (res.status > 0) {
            resolve(res.data);
        } else {
            // this.errorHandle(res);
        }
        if (res.data.message && this.store.state.msflag === true) {
            // 消息弹窗
            mdui.snackbar({
                message: res.data.message,
                position: 'top'
            });
        }
        // 恢复默认值
        this.store.commit("setMsFlag", true);
        // 关闭loding动画
        this.store.commit("lodingEnd");
    }
}